import React from 'react';

const useWebEngage = () => {
    const webEngage = (window as any)?.webengage;

    return { webEngage };
};

export default useWebEngage;
